import * as React from 'react'

export const CloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.3594 6.39844L12.2578 10.5L16.3594 14.6406C16.8672 15.1094 16.8672 15.9297 16.3594 16.3984C15.8906 16.9062 15.0703 16.9062 14.6016 16.3984L10.5 12.2969L6.35938 16.3984C5.89062 16.9062 5.07031 16.9062 4.60156 16.3984C4.09375 15.9297 4.09375 15.1094 4.60156 14.6406L8.70312 10.5L4.60156 6.39844C4.09375 5.92969 4.09375 5.10938 4.60156 4.64062C5.07031 4.13281 5.89062 4.13281 6.35938 4.64062L10.5 8.74219L14.6016 4.64062C15.0703 4.13281 15.8906 4.13281 16.3594 4.64062C16.8672 5.10938 16.8672 5.92969 16.3594 6.39844Z"
        fill="currentColor"
      />
    </svg>
  )
}
